<footer>
  <img
    src="/assets/image/logo/powered-by-pq.svg"
    transAlt="branding.powered_by_pq"
  >
</footer>
